<template>
    <div class="container-fluid">
        <b-grid
            caption="submission list"
            :tableOptions="tableOptions"
            :items="items"
            :columns="columns"
            :show-filter="false"
            :show-paging="true"
            :current-item-count="numberOfReturnedItems"
            @optionChange="getSubmissionItems">
            <template v-slot:cell.fileName="{item, column}">                
                <a :href="`FileDownload.ashx?file=${item.id}&type=0&source=dcra`" class='btn btn-link' v-if="item.numberOfDeaths > 0">{{ item.fileName }}</a>
                <span v-else class="fst-italic">No File Available</span>
            </template>
        </b-grid>
    </div>
</template>
<script setup lang="ts">
import {computed, ref, watch, onMounted} from "vue";
import {BTableColumn, BTableOptions} from "./BTable/BTable.types";
import {BFilter, BFilterableField} from "./BFilterEditor/BFilterEditor.types";
import BGrid from "./BGrid/BGrid.vue";
import { useDcraStore } from "@/stores/dcraStore";
import { Submission } from "./DcraEditor/schema";

const props = defineProps<{
}>();

const dcraStore = useDcraStore();
var numberOfReturnedItems = ref(0);

//table settings and column info
var tableOptions = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [
        {
            key: "lastUpdateDate",
            isDescending: true,
        },
    ],
    pagingMode: "noTotal",
} as BTableOptions);

const columns = computed(() => {
    let data: BTableColumn[] = [];

    data.push(
        {key: "quarter", text: "Quarter", sortable: false, value: (item) => item.quarter},
        {key: "lastUpdateDate", text: "Last Update Date", sortable: false, value: (item) => item.lastUpdateDate},
        {key: "numberOfDeaths", text: "Number Of Deaths", sortable: false, value: (item) => item.numberOfDeaths},
        {key: "fileName", text: "File Name", sortable: false, value: (item) => item.filename}
    );

    return data;
});

var items = ref([] as Submission[]);
function getSubmissionItems() {
    dcraStore
        .getSubmissionItems(tableOptions.value)
        .then((response) => { 
             
            if (tableOptions.value.pagingMode == "noTotal" && response?.data?.data?.length > 0) {
                items.value = response.data.data.slice(0, tableOptions.value.itemsPerPage);
            } else {
                items.value = response.data.data;
            }                     

            numberOfReturnedItems.value = response.data.data.length;
            
            tableOptions.value.totalItemCount = response.data.total;
        });
}

//LifeCycle Hooks
onMounted(()=> {
    getSubmissionItems();
});

</script>

